import { RootReducer } from 'rootReducer';

export const getIsTheaterMode = (state: RootReducer) => state.videoPlayerReducer.isTheaterMode;
